import React from 'react';
import { Link } from 'react-router-dom';

import SignOutButton from '../SignOut';
import * as ROUTES from '../../constants/routes';
import { AuthUserContext } from '../Session'; 

const Navigation = () => (
  <div id="topbar">
    <img className="logo" src="/images/Logo_black.png" alt="logo" />
    <AuthUserContext.Consumer>
      {authUser =>
        authUser ? <NavigationAuth /> : <NavigationNonAuth />
      }
    </AuthUserContext.Consumer>
  </div>
);

const toggleTopNavMenu = () => {
  var x = document.getElementById("myTopnav");
  if (x.className === "topnav") {
    x.className += " responsive";
  } else {
    x.className = "topnav";
  }
}

const NavigationAuth = () => (
  <ul className="topnav" id="myTopnav">
    <li>
      <Link to={ROUTES.DASHBOARD} onClick={toggleTopNavMenu}>Home</Link>
    </li>
    <li>
      <Link to={ROUTES.USER_DASHBOARD} onClick={toggleTopNavMenu}>Hackerspace</Link>
    </li>
    <li>
      <Link to={ROUTES.ACCOUNT} onClick={toggleTopNavMenu}>Reset my Password</Link>
    </li>
    <li>
      <SignOutButton />
    </li>
    <li className="icon">
      <a href="#" onClick={toggleTopNavMenu}>
        <i className="fa fa-bars"></i>
      </a>
    </li>
  </ul>
);
 
const NavigationNonAuth = () => (
  <ul className="topnav" id="myTopnav">
    <li>
      <Link to={ROUTES.SIGN_IN}>Sign In</Link>
    </li>
  </ul>
);
 
export default Navigation;